
import React from 'react';
import { Star } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface RatingSelectorProps {
  rating: number;
  onRatingChange: (rating: number) => void;
}

const RatingSelector: React.FC<RatingSelectorProps> = ({ rating, onRatingChange }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex justify-center gap-1">
      {[1, 2, 3, 4, 5].map((value) => (
        <button
          key={value}
          type="button"
          className={`focus:outline-none transition-all ${isMobile ? 'p-2' : ''}`}
          onClick={() => onRatingChange(value)}
        >
          <Star
            size={isMobile ? 32 : 28}
            className={`transition-colors ${
              value <= rating 
                ? 'text-yellow-400 fill-yellow-400' 
                : 'text-gray-300'
            }`}
          />
        </button>
      ))}
    </div>
  );
};

export default RatingSelector;
